<template>
  <div class="mainPage">
    <Visual />
    <NextMatch :nextGameStatus="nextGameStatus" :nextGames="nextGames" :prevGames="prevGames" />
    <PrevMatch :prevGameStatus="prevGameStatus" :prevGames="prevGames" />
    <News />
    <Video />
    <Shop />
    <Banner />
    <!--<Player />-->
    <YouthTeam />
    <Ranking />
    <IntrdCard />
    <Sponsor />
  </div>
</template>

<script>
import Visual from '@/components/Main/Visual'
import NextMatch from '@/components/Main/NextMatch.vue';
import PrevMatch from '@/components/Main/PrevMatch.vue';
import Shop from '@/components/Main/Shop.vue';
import Banner from '@/components/Main/Banner.vue';
import YouthTeam from '@/components/Main/YouthTeam.vue';
// import Player from '@/components/Main/Player.vue';
import News from '@/components/Main/News.vue';
import Ranking from '@/components/Main/Ranking.vue';
import IntrdCard from '@/components/Main/IntrdCard.vue';
import Sponsor from '@/components/Main/Sponsor.vue';
import dayjs from "dayjs";
import Video from '@/components/Main/Video.vue';

export default {
  name: 'MainView',
  components: {
    Video,
    Visual,
    NextMatch,
    PrevMatch,
    Shop,
    Banner,
    // Player,
    YouthTeam,
    News,
    Ranking,
    IntrdCard,
    Sponsor
  },
  data() {
    return {
      nextGameStatus: false,
      prevGameStatus: false,
      nextGames: [],
      prevGames: [],
      thisyear: dayjs().format('YYYY'),
    }
  },
  created() {
    this.getMatch();
  },
  methods: {
    async getMatch() {
      const {data} = await this.$http.get(`/game?year=${this.thisyear}`)
      if (data.success) {
        if(data.data.next_game.length > 0) {
          this.nextGameStatus = true;
          this.nextGames = data.data.next_game;
        }
        if(data.data.past_game.length > 0) {
          this.prevGameStatus = true;
          this.prevGames = data.data.past_game;
        } else {
          // 해당 년도 지난 경기가 없을 경우 지난해 지난 경기
          const lastYear = dayjs().subtract(1, 'year').format('YYYY');
          const {data} = await this.$http.get(`/game?year=${lastYear}`)
          if(data.success) {
            this.prevGameStatus = true;
            this.prevGames = data.data.past_game;
          }
        }
      }
    }
  }
}
</script>
